module.exports = __webpack_public_path__ + "media/images/como_funciona/tutorial-check-value-a66b222d2ab9980e58a1c0ac86ffb4da.svg";